import '../../assets/css/components/side-bar.css';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import * as routes from '../../utils/constants/routes';
import { useEffect, useState } from 'react';
import { AdminRequest, PriceSearchRequest } from '../../services';
import { useSelector } from 'react-redux';

const Header = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const storage = useSelector((state) => state.storage);
    const [pageName, setPageName] = useState([]);
    const { organization, changeRequestType, isManager, authority } = storage;

    const openMenu = () => {
        const el = document.getElementsByClassName('sb-slide-right');

        if (el[0].classList.contains('okc-sidebar--compact')) {
            el[0].classList.remove('okc-sidebar--compact');
        } else {
            el[0].classList.add('okc-sidebar--compact');
        }
    };

    const getPageName = () => {
        const getRoutes = getPageNameRoutes();

        setPageName(getRoutes.find((item) => item.href === location.pathname)?.name);
    };

    const getPageNameRoutes = () => {
        switch (organization) {
            case AdminRequest.organization.STORE:
                switch (changeRequestType) {
                    case PriceSearchRequest.changeRequestType.COMPETITOR:
                        return isManager ? routes.ALLOW_COMPETITOR_MANAGER : routes.ALLOW_COMPETITOR_EDITOR;
                    case PriceSearchRequest.changeRequestType.FRESHNESS:
                        return isManager ? routes.ALLOW_FRESHNESS_MANAGER : routes.ALLOW_FRESHNESS_EDITOR;
                    case PriceSearchRequest.changeRequestType.INSTRUCTION:
                        return isManager ? routes.ALLOW_INSTRUCTION_MANAGER : routes.ALLOW_INSTRUCTION_EDITOR;
                    default:
                        return [];
                }
            case AdminRequest.organization.HEADQUARTERS:
                return isManager ? routes.ALLOW_HEADQUARTER_ONLY_MANAGER : routes.ALLOW_HEADQUARTER_ONLY_EDITOR;
            case AdminRequest.organization.GROCERY_HEADQUARTERS:
                return isManager ? routes.ALLOW_GROCERY_HEADQUARTER_ONLY_MANAGER : routes.ALLOW_GROCERY_HEADQUARTER_ONLY_EDITOR;
            case AdminRequest.organization.IT_HEADQUARTERS:
                switch (authority) {
                    case AdminRequest.authority.ADMIN:
                        return routes.ALLOW_IT_HEADQUARTER_ONLY;
                    case AdminRequest.authority.MANAGER:
                        return routes.ALLOW_IT_HEADQUARTER_ONLY;
                    case AdminRequest.authority.EDITOR:
                        return routes.ALLOW_IT_HEADQUARTER_ONLY;
                    default:
                        return [];
                }
            default:
                return [];
        }
    };

    useEffect(() => {
        getPageName();
    }, [location]);
    return (
        <div className="okc-header h-slide-bottom">
            <button onClick={() => openMenu()} className="btn btn--icon btn--square okc-header__sidebar-trigger">
                <i className="icon-menu"></i>
                <span className="btn-text"></span>
            </button>
            <div className="okc-header__company">
                {t('okc.title.header')}
                <span className="okc-header__page">{pageName}</span>
            </div>
        </div>
    );
};

export default Header;
